import React, { useState, useEffect, useRef, useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { getBranding } from "../../hooks/tennant";
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import BackupTableRoundedIcon from '@mui/icons-material/BackupTableRounded';
import "../navbar/navbar.scss"

const Navbar = () => {
    const [openModal, setOpenModal] = useState(null);
    const [branding, setBranding] = useState(null);

    const { logout, user, hasPermission, isLoading } = useContext(AuthContext);
    const modalRef = useRef(null);

    useEffect(() => {
        const loadBranding = async () => {
            try {
                const data = await getBranding();
                setBranding(data);
            } catch (error) {
                console.error("Branding konnte nicht geladen werden:", error);
            }
        };

        loadBranding();
    }, []);

    const handleClickAccount = () => {
        setOpenModal(prev => (prev === "account" ? null : "account"));
    };

    const handleClickNotifications = () => {
        setOpenModal(prev => (prev === "notifications" ? null : "notifications"));
    };

    const handleLogout = () => {
        logout();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setOpenModal(null);
            }
        };

        if (openModal) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openModal]);

    return isLoading ? (<div />) : (
        <div className="nav">
            <div className="topBar">
                <div className="left">
                    {branding &&
                        <NavLink to="/">
                            <img src={`/assets/branding/${branding.logoNav}`} alt="Logo" className="logo desktop" />
                        </NavLink>
                    }
                    <div className="navigation">
                        {hasPermission("map", "read") &&
                            <NavLink to="/map" className="block">
                                <MapRoundedIcon />
                                <span>Karte</span>
                            </NavLink>
                        }
                        {hasPermission("planner", "read") &&
                            <NavLink to="/calendar" className="block">
                                <EventRoundedIcon />
                                <span>Kalender</span>
                            </NavLink>
                        }
                        {hasPermission("planner", "read") &&
                            <NavLink to="/list" className="block">
                                <ChecklistRoundedIcon />
                                <span>Auftragsliste</span>
                            </NavLink>
                        }
                        {hasPermission("data", "read") &&
                            <NavLink to="/data" className="block">
                                <BackupTableRoundedIcon />
                                <span>Stammdaten</span>
                            </NavLink>
                        }
                        {hasPermission("company", "read") &&
                            <NavLink to="/customer" className="block">
                                <PeopleOutlineRoundedIcon />
                                <span>Kundenstammdaten</span>
                            </NavLink>
                        }
                        {hasPermission("company", "read") &&
                            <NavLink to="/deliverynotes" className="block">
                                <DescriptionOutlinedIcon />
                                <span>Lieferscheine</span>
                            </NavLink>
                        }
                        {hasPermission("company", "read") &&
                            <NavLink to="/bills" className="block">
                                <ReceiptLongRoundedIcon />
                                <span>Rechnungen</span>
                            </NavLink>
                        }
                        {hasPermission("operator", "read") &&
                            <NavLink to="/operator" className="block">
                                <ChecklistRoundedIcon />
                                <span>Fahrten</span>
                            </NavLink>
                        }
                    </div>
                </div>
                {user &&
                    <div className="right" ref={modalRef}>
                        <div className="notifications" onClick={handleClickNotifications}>
                            <NotificationsNoneRoundedIcon />
                        </div>
                        {openModal === "notifications" &&
                            <div className="popUp">
                                <div className="list">
                                    <span>Keine Benachrichtigungen</span>
                                </div>
                            </div>
                        }
                        <div className="account" onClick={handleClickAccount}>
                            <span>{user?.username?.[0]}</span>
                        </div>
                        {openModal === "account" &&
                            <div className="popUp">
                                <div className="user">
                                    <span className="username">{user?.name} {user?.surname}</span>
                                    <span className="email">{user?.email}</span>
                                </div>
                                <div className="links">
                                    <Link onClick={handleClickAccount} to="settings">Einstellungen</Link>
                                    <span onClick={handleLogout}>Abmelden</span>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    )
};

export default Navbar;